export default function(obj, name) {
  obj[name] = {
    name,
    REQUEST: `${name}_REQUEST`,
    SUCCESS: `${name}_SUCCESS`,
    ERROR: `${name}_ERROR`,
    triplet: [`${name}_REQUEST`, `${name}_SUCCESS`, `${name}_ERROR`],
  };
}
